import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Paths, SHAs and identifiers are typed in mono. */
  mono?: boolean;
  invalid?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, mono, invalid, ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-8 w-full rounded-sm border bg-raised px-2 text-sm text-ink placeholder:text-ink-3',
        'border-rule-strong transition-colors focus:border-live focus:outline-none focus:ring-1 focus:ring-live',
        'disabled:cursor-not-allowed disabled:bg-sunken disabled:text-ink-3',
        mono && 'font-mono text-xs tracking-tight',
        invalid && 'border-danger focus:border-danger focus:ring-danger',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
